export default {
    series: [],
    labels: [],
    chart: {
        type: 'donut',
    }, legend: {
        labels: {
            colors: '#9ca3af',
        },
        fontSize: '14px'
    }, dataLabels: {
        enabled: true,
        style: {
            fontSize: '12px',
            fontWeight: 'bold',
            color: '#FFF'
        }, dropShadow: {
            enabled: false
        }
    }, plotOptions: {
        pie: {
            donut: {
                size: '70%'
            }
        }
    }, stroke: {
        colors: ['transparent']
    }, responsive: [{
        breakpoint: 640,
        options: {
            legend: {
                position: 'bottom'
            }
        }
    }]
};